import React from 'react'
import { Box } from '@theme-ui/components'
import PropTypes from 'prop-types'

const Container = React.forwardRef((props, ref) => {
  const regular = ['100%', '100%', '100%', '1157px']
  const pillar = ['100%', '100%', '100%', '770px']
  const maxWidth = props.variant === 'pillar' ? pillar : regular
  return (
    <Box
      ref={ref}
      variant="container"
      {...props}
      __themeKey="layout"
      __css={{
        width: '100%',
        maxWidth,
        mx: 'auto',
        my: 0,
        px: 0,
        '@media(max-width: 899px)': {
          px: 4
        },
        '@media(max-width: 599px)': {
          px: 3
        }
      }}
    />
  )
})

Container.displayName = 'Container'

Container.propTypes = {
  variant: PropTypes.string,
}

Container.defaultProps = {
  variant: 'regular',
}

export default Container
